module.exports = __webpack_public_path__ + "static/media/purple-mission.78267264.svg";